import {defineStore} from "pinia";


export const useConsultorioStore = defineStore("consultorioStore", {
    state: () =>
        ({
            loading: false as boolean,
            showDialog: false as boolean,
            showDialogFuncionario: false as boolean,
            citas: [],
            reservas: [],
            pacientes: [],
            tratamientos: [],
            paciente: {},
            caras: [],
            documentos: [],
            detalle_odontograma: [],
            otros_tratamientos: [],
            productos: [],
            insumos: [],
            preguntas: [],
            cotizaciones: [],
            pagos: [],
            especialidades: [],
            resinas: [] as any[],
            fichas_artificiales: [] as any[],

            
            pagination: {
              per_page: 0,
              current_page: 1,
              last_page: 0,
            },
            
        }),
});